import React, { Component } from "react";
import EditButton from "../components/UsersEditButton";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Edit from "../assets/edit.svg";

export default class RoutinItem extends Component {
  render() {
    return (
      <div className="routinItem">
        <div
          style={{
            fontSize: "16px",
            marginTop: "10px",
            color: "var(--black1)",
          }}
        >
          {this.props.placeName}
        </div>
        <div
          style={{
            fontSize: "14px",
            marginTop: "5px",
            color: "var(--gray3)",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div>{this.props.statusText}</div>

          <OverlayTrigger
            placement="bottom"
            delay={{ show: 200, hide: 200 }}
            overlay={
              <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
                ویرایش
              </Tooltip>
            }
          >
            <div
              style={{
                cursor: "pointer",
                userSelect: "none",
                marginRight: "10px",
              }}
              onClick={() => this.props.editStatusText(this.props.item)}
            >
              <img
                src={Edit}
                alt=""
                style={{ objectFit: "contain", height: "15px" }}
              />
            </div>
          </OverlayTrigger>
        </div>
        <div
          style={{
            flex: "1",
            width: "100%",
            overflow: "auto",
            marginTop: "10px",
            padding: "0px 5px",
          }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "1px",
              backgroundColor: "var(--gray4)",
              marginBottom: "5px",
            }}
          />
          {this.props.item.childs.map((item, i) => {
            return (
              <div className="routinChild" key={i}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>{item.title}</div>
                  <div
                    style={{
                      color: "var(--gray3)",
                      fontSize: "12px",
                      marginTop: "10px",
                    }}
                  >
                    {item.foodList.length} محصول
                  </div>
                  <div style={{ color: "var(--gray3)", fontSize: "12px" }}>
                    {item.orderStationList.length} ایستگاه
                  </div>
                  <div style={{ color: "var(--gray3)", fontSize: "12px" }}>
                    {item.businessUserList ? item.businessUserList.length : 0}{" "}
                    کاربر
                  </div>
                </div>

                <EditButton
                  height="16px"
                  editItem={() => this.props.editItem(item)}
                  deleteItem={() => this.props.deleteItem(item)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
